import { format } from 'date-fns';

export const NERVE_BLOCKS_APP_ID = '5e98254f2d1ce10e9431f525';

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const SUBSCRIPTION_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
];

export const DATE_RANGE_OPTIONS = [
  { value: '24hours', label: 'Last 24 Hours' },
  { value: '7days', label: 'Last 7 Days' },
  { value: '30days', label: 'Last 30 Days' },
  { value: '90days', label: 'Last 90 Days' },
  { value: 'custom', label: 'Custom' },
];

export const TABLE_SUBSCRIPTION_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
  { value: 'license', label: 'License' },
  { value: 'not_subscribed', label: 'No subscription' },
];

export const LAST_ANSWER_DATE_FILTER_OPTIONS = [
  { value: '', label: 'All dates' },
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last_7_days', label: 'Last 7 days' },
  { value: 'last_30_days', label: 'Last 30 days' },
  { value: 'older_30_days', label: 'Older than 30 days' },
];

export const TRUE_FALSE_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'true', label: 'True' },
  { value: 'false', label: 'False' },
];

export const formatLocalDate = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return new Date().toISOString().slice(0, 10);
  }
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().slice(0, 10);
};

export const computePresetDates = (range) => {
  const now = new Date();
  let startDate;
  let endDate = new Date();
  let dateRange = range;

  switch (range) {
    case '24hours':
      startDate = new Date(Date.now() - 24 * 60 * 60 * 1000);
      break;
    case '7days':
      startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      break;
    case '30days':
      startDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);
      break;
    case '90days':
      startDate = new Date(Date.now() - 90 * 24 * 60 * 60 * 1000);
      break;
    default:
      dateRange = '7days';
      startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
  }

  return { dateRange, startDate, endDate };
};

export const getApiBaseUrl = () =>
  (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

export const downloadCsv = (rows, filename) => {
  if (!rows.length) return;
  const headers = Object.keys(rows[0]);
  const escape = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`;
  const lines = [
    headers.join(','),
    ...rows.map((row) => headers.map((key) => escape(row[key])).join(',')),
  ];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
};

export const formatDisplayDate = (value) => {
  if (!value) return '-';
  const d = new Date(value.includes('T') ? value : `${value}T00:00:00`);
  if (Number.isNaN(d.getTime())) return value;
  return format(d, 'yyyy-MM-dd');
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const normalized = typeof value === 'string' ? value.replace(/(\.\d{3})\d+(Z)$/i, '$1$2') : value;
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return '-';
  return format(d, 'yyyy-MM-dd HH:mm:ss');
};

export const exportTimestamp = () => format(new Date(), 'yyyy-MM-dd');
